// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ReleaseMinified,
  ReleaseMinifiedFromJSON,
  ReleaseMinifiedToJSON,
  UserMinified,
  UserMinifiedFromJSON,
  UserMinifiedToJSON,
} from "./";

/**
 *
 * @export
 * @interface Build
 */
export interface Build {
  /**
   *
   * @type {number}
   * @memberof Build
   */
  id: number;
  /**
   * Human-facing version identifier of the software the tests run against
   * @type {string}
   * @memberof Build
   */
  version: string;
  /**
   * Free-form environment name (e.g. Production, Staging, UAT)
   * @type {string}
   * @memberof Build
   */
  environment?: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  releaseDate?: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  notes?: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  releaseNotesUrl?: string;
  /**
   * How the build was created. `manual` is entered by a user; `ci` is ingested from a pipeline.
   * @type {string}
   * @memberof Build
   */
  source: BuildSourceEnum;
  /**
   * Registry key of the version-control provider (e.g. azure_devops, github, gitlab)
   * @type {string}
   * @memberof Build
   */
  vcsProvider?: string;
  /**
   * Registry key of the CI provider that produced the build
   * @type {string}
   * @memberof Build
   */
  ciProvider?: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  commitSha?: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  branch?: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  tag?: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  repoUrl?: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  commitUrl?: string;
  /**
   * Provider build/run identifier (string — provider IDs are not always small ints)
   * @type {string}
   * @memberof Build
   */
  buildNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  buildUrl?: string;
  /**
   * Opaque provider reference used to de-duplicate ingested builds
   * @type {string}
   * @memberof Build
   */
  externalRef?: string;
  /**
   * Provider-specific fields (Azure buildId/definitionId, GitHub run_id, GitLab pipeline_id, etc.)
   * @type {{ [key: string]: any; }}
   * @memberof Build
   */
  metadata?: { [key: string]: any };
  /**
   *
   * @type {ReleaseMinified}
   * @memberof Build
   */
  release?: ReleaseMinified;
  /**
   * True when the build's release was assigned manually — a manual assignment always overrides pattern auto-matching (TCV-6723).
   * @type {boolean}
   * @memberof Build
   */
  releaseManual?: boolean;
  /**
   *
   * @type {number}
   * @memberof Build
   */
  project: number;
  /**
   *
   * @type {UserMinified}
   * @memberof Build
   */
  createdBy?: UserMinified;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof Build
   */
  updatedAt: string;
}

export function BuildFromJSON(json: any): Build {
  return {
    id: json["id"],
    version: json["version"],
    environment: !exists(json, "environment") ? undefined : json["environment"],
    releaseDate: !exists(json, "release_date")
      ? undefined
      : json["release_date"],
    notes: !exists(json, "notes") ? undefined : json["notes"],
    releaseNotesUrl: !exists(json, "release_notes_url")
      ? undefined
      : json["release_notes_url"],
    source: json["source"],
    vcsProvider: !exists(json, "vcs_provider")
      ? undefined
      : json["vcs_provider"],
    ciProvider: !exists(json, "ci_provider") ? undefined : json["ci_provider"],
    commitSha: !exists(json, "commit_sha") ? undefined : json["commit_sha"],
    branch: !exists(json, "branch") ? undefined : json["branch"],
    tag: !exists(json, "tag") ? undefined : json["tag"],
    repoUrl: !exists(json, "repo_url") ? undefined : json["repo_url"],
    commitUrl: !exists(json, "commit_url") ? undefined : json["commit_url"],
    buildNumber: !exists(json, "build_number")
      ? undefined
      : json["build_number"],
    buildUrl: !exists(json, "build_url") ? undefined : json["build_url"],
    externalRef: !exists(json, "external_ref")
      ? undefined
      : json["external_ref"],
    metadata: !exists(json, "metadata") ? undefined : json["metadata"],
    release: !exists(json, "release")
      ? undefined
      : ReleaseMinifiedFromJSON(json["release"]),
    releaseManual: !exists(json, "release_manual")
      ? undefined
      : json["release_manual"],
    project: json["project"],
    createdBy: !exists(json, "created_by")
      ? undefined
      : UserMinifiedFromJSON(json["created_by"]),
    createdAt: json["created_at"],
    updatedAt: json["updated_at"],
  };
}

export function BuildToJSON(value?: Build): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    version: value.version,
    environment: value.environment,
    release_date: value.releaseDate,
    notes: value.notes,
    release_notes_url: value.releaseNotesUrl,
    source: value.source,
    vcs_provider: value.vcsProvider,
    ci_provider: value.ciProvider,
    commit_sha: value.commitSha,
    branch: value.branch,
    tag: value.tag,
    repo_url: value.repoUrl,
    commit_url: value.commitUrl,
    build_number: value.buildNumber,
    build_url: value.buildUrl,
    external_ref: value.externalRef,
    metadata: value.metadata,
    release: ReleaseMinifiedToJSON(value.release),
    release_manual: value.releaseManual,
    project: value.project,
    created_by: UserMinifiedToJSON(value.createdBy),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum BuildSourceEnum {
  Manual = "manual",
  Ci = "ci",
}
